const openModalButtons = document.querySelectorAll('.open-modal-button');

if (openModalButtons.length > 0) {

  const modalOuter = document.querySelector('.modal-outer');
  const modalCloseButton = document.querySelector('.modal-close');

  const downloadSourceInput = document.querySelector('#fielddiurkhk'); // CM hidden field
  const downloadUrlInput = document.querySelector('#fielddiuyau'); // CM hidden field

  const cmForm = document.querySelector('#subForm');

  // Open modal & set hidden fields
  openModalButtons.forEach(button => {
    button.addEventListener('click', (event) => {
      event.preventDefault();

      const downloadType = button.dataset.download || 'Unknown download';
      const fileUrl = button.getAttribute('href');

      // Set hidden fields for CM
      if (downloadSourceInput) downloadSourceInput.value = downloadType;
      if (downloadUrlInput) downloadUrlInput.value = fileUrl;

      // Save PDF URL in localStorage so it can be used on the thank-you page
      if (fileUrl) localStorage.setItem('downloadUrl', fileUrl);

      if (modalOuter) modalOuter.classList.add('open');
    });
  });

  // Close modal
  if (modalCloseButton && modalOuter) {
    modalCloseButton.addEventListener('click', () => {
      modalOuter.classList.remove('open');
    });

    modalOuter.addEventListener('click', (event) => {
      if (!event.target.closest('.modal-inner')) {
        modalOuter.classList.remove('open');
      }
    });
  }

  // Handle CM form submit
  if (cmForm) {
    cmForm.addEventListener('submit', function(event) {
      // Let CM handle submission normally (redirect to thank-you page)
      // The thank-you page will read localStorage to trigger the download
    });
  }
}
